__webpack_require__.p = "/mongolia/";